const EcoCartPlus: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
        <rect x="9.89014" y="15.7778" width="12.9869" height="1.44444" rx="0.722222" fill="currentColor" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.3836 23C15.9851 23 15.6621 22.677 15.6621 22.2785L15.6621 10.7215C15.6621 10.323 15.9851 10 16.3836 10C16.7821 10 17.1051 10.323 17.1051 10.7215V22.2785C17.1051 22.677 16.7821 23 16.3836 23Z"
            fill="currentColor"
        />
    </svg>
);

export default EcoCartPlus;
